// removed by extract-text-webpack-plugin
module.exports = {"bg":"_3Ba-wYpS0RnqCm4Ipt8EkH","cardContent":"_3C9E2777lws1Wvyj4YIMz6","top":"j-rW1p9fHxvEBIix4qtxp","naopublicado":"_1PJWxwWotYKpDix1swJteH","publicado":"_1AdjrCJcAK0L8AK4LR4473","eventlink":"_1P4SCEbQtzoOcIE2k4N30G","copied":"_398zbr1SU86JbElBpgV23G","content":"_3i-kdlaZkqpQXvsUJhW9lK","tips":"_3hnMgz1hfBV1JgAZ5_IkZ4","tipimg":"_1IpdatdoH-_be85wIWFFEv","config":"_1KC3hqmMI8dzTghDeYLZPi","titlePublish":"_1o0-woPoh4BJNr06GRxE","msgPublish":"_30qnyUB3-08GUI938OGp3E"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/EventOk/styles.css
// module id = 420
// module chunks = 39